module.exports = __webpack_public_path__ + "img/megafon.d231ec5a.svg";